import React, {Component} from "react";

import * as componentTypes from "../../../constants/componentTypes";

import AlternativeFormulasModal from "./modal/AlternativeFormulasModal";
import AutotaskModal from "./modal/AutotaskModal";
import CleanAllChannelsModal from "./modal/CleanAllChannelsModal";
import CleanChannelsModal from "./modal/CleanChannelsModal";
import ClosestColorsModal from "./modal/ClosestColorsModal";
import ColorantRefillHistoryModal from "./modal/ColorantRefillHistoryModal";
import CorrectionHistoryModal from "./modal/CorrectionHistoryModal";
import CanisterRefillDetailHistoryModal from "./modal/CanisterRefillDetailHistoryModal";
import CustomFandecksModal from "./modal/CustomFandecksModal";
import CustomPackageSettingsModal from "./modal/CustomPackageSettingsModal";
import CustomersModal from "./modal/CustomersModal";
import DatePickerModal from "../../global/modal/DatePickerModal";
import DebugModal from "../../global/modal/DebugModal";
import DeleteFavoriteFolderModal from "./modal/DeleteFavoriteFolderModal";
import EditColorantsModal from "./modal/EditColorantsModal";
import EditCurrencyModal from "./modal/EditCurrencyModal";
import EditCustomFandeckModal from "./modal/EditCustomFandeckModal";
import EditCustomerModal from "./modal/EditCustomerModal";
import EditFormulaRgbModal from "./modal/EditFormulaRgbModal";
import EditMarginModal from "./modal/EditMarginModal";
import EditNoteModal from "./modal/EditNoteModal";
import EditPasswordModal from "./modal/EditPasswordModal";
import EditServerModal from "./modal/EditServerModal";
import EditStatsNoteModal from "./modal/EditStatsNoteModal";
import EditUserModal from "./modal/EditUserModal";
import FileTransferTaskModal from "../../global/modal/FileTransferTaskModal";
import HideItemsModal from "./modal/HideItemsModal";
import HistoricalFormulasModal from "./modal/HistoricalFormulasModal";
import ChangeDatabaseModal from "../../global/modal/ChangeDatabaseModal";
import ChangeLogModal from "../../global/modal/ChangeLogModal";
import CheaperColorsModal from "./modal/CheaperColorsModal";
import ImportDataModal from "./modal/ImportDataModal";
import ImportPriceDataModal from "./modal/ImportPriceDataModal";
import MachineErrorsModal from "../../global/modal/MachineErrorsModal";
import MasterProductsModal from "./modal/MasterProductsModal";
import MatchingColorantsModal from "./modal/MatchingColorantsModal";
import MatchingDispenseFormulaModal from "./modal/MatchingDispenseFormulaModal";
import MatchingMeasurementModal from "./modal/MatchingMeasurementModal";
import NoteModal from "./modal/NoteModal";
import OrderNotificationModal from "../../../containers/modal/OrderNotificationModal";
import PartialUpdatesModal from "./modal/PartialUpdatesModal";
import PrintModal from "../../global/modal/PrintModal";
import PrintPreviewModal from "./modal/PrintPreviewModal";
import PrintPreviewOrderModal from "../../global/modal/PrintPreviewOrderModal";
import PrintTaskModal from "../../global/modal/PrintTaskModal";
import ProductFilePreviewModal from "../../global/modal/ProductFilePreviewModal";
import ProductFilesModal from "./modal/ProductFilesModal";
import ProgressBarModal from "../../../containers/modal/ProgressBarModal";
import PurgeAllModal from "./modal/PurgeAllModal";
import RecirculateAllChannelsModal from "./modal/RecirculateAllChannelsModal";
import RecirculateChannelsModal from "./modal/RecirculateChannelsModal";
import RetintModal from "./modal/RetintModal";
import SetCanisterUfiCodeModal from "./modal/SetCanisterUfiCodeModal";
import StirAllCanistersModal from "./modal/StirAllCanistersModal";
import TranslationModal from "./modal/TranslationModal";
import TicketingModal from "./modal/TicketingModal";
import SearchInStandardFormulasModal from "./modal/SearchInStandardFormulasModal";
import QualityControlModal from "./modal/QualityControlModal";

export default class Modal extends Component {
    render() {
        switch (this.props.type) {
            case componentTypes.ALTERNATIVE_FORMULAS_MODAL:
                return <AlternativeFormulasModal {...this.props} />;
            case componentTypes.AUTOTASK_MODAL:
                return <AutotaskModal {...this.props} />;
            case componentTypes.CLEAN_ALL_CHANNELS_MODAL:
                return <CleanAllChannelsModal {...this.props} />;
            case componentTypes.CLEAN_CHANNELS_MODAL:
                return <CleanChannelsModal {...this.props} />;
            case componentTypes.CLOSEST_COLORS_MODAL:
                return <ClosestColorsModal {...this.props} />;
            case componentTypes.COLORANT_REFILL_HISTORY_MODAL:
                return <ColorantRefillHistoryModal {...this.props} />;
            case componentTypes.CORRECTION_HISTORY_MODAL:
                return <CorrectionHistoryModal {...this.props} />;
            case componentTypes.COLORANT_UFI_CODES_MODAL:
                return <CanisterRefillDetailHistoryModal {...this.props} />;
            case componentTypes.CUSTOM_FANDECKS_MODAL:
                return <CustomFandecksModal {...this.props} />;
            case componentTypes.CUSTOM_PACKAGE_SETTINGS_MODAL:
                return <CustomPackageSettingsModal {...this.props} />;
            case componentTypes.CUSTOMERS_MODAL:
                return <CustomersModal {...this.props} />;
            case componentTypes.DATE_PICKER_MODAL:
                return <DatePickerModal {...this.props} />;
            case componentTypes.DEBUG_MODAL:
                return <DebugModal {...this.props} />;
            case componentTypes.DELETE_FAVORITE_FOLDER_MODAL:
                return <DeleteFavoriteFolderModal {...this.props} />;
            case componentTypes.EDIT_COLORANTS_MODAL:
                return <EditColorantsModal {...this.props} />;
            case componentTypes.EDIT_CURRENCY_MODAL:
                return <EditCurrencyModal {...this.props} />;
            case componentTypes.EDIT_CUSTOM_FANDECK_MODAL:
                return <EditCustomFandeckModal {...this.props} />;
            case componentTypes.EDIT_CUSTOMER_MODAL:
                return <EditCustomerModal {...this.props} />;
            case componentTypes.EDIT_FORMULA_RGB_MODAL:
                return <EditFormulaRgbModal {...this.props} />;
            case componentTypes.EDIT_MARGIN_MODAL:
                return <EditMarginModal {...this.props} />;
            case componentTypes.EDIT_NOTE_MODAL:
                return <EditNoteModal {...this.props} />;
            case componentTypes.EDIT_PASSWORD_MODAL:
                return <EditPasswordModal {...this.props} />;
            case componentTypes.EDIT_SERVER_MODAL:
                return <EditServerModal {...this.props} />;
            case componentTypes.EDIT_STATS_NOTE_MODAL:
                return <EditStatsNoteModal {...this.props} />;
            case componentTypes.EDIT_USER_MODAL:
                return <EditUserModal {...this.props} />;
            case componentTypes.FILE_TRANSFER_TASK_MODAL:
                return <FileTransferTaskModal {...this.props} />;
            case componentTypes.HIDE_ITEMS_MODAL:
                return <HideItemsModal {...this.props} />;
            case componentTypes.HISTORY_FORMULAS_MODAL:
                return <HistoricalFormulasModal {...this.props} />;
            case componentTypes.CHANGE_DATABASE_MODAL:
                return <ChangeDatabaseModal {...this.props} />;
            case componentTypes.CHANGELOG_MODAL:
                return <ChangeLogModal {...this.props} />;
            case componentTypes.CHEAPER_COLORS_MODAL:
                return <CheaperColorsModal {...this.props} />;
            case componentTypes.IMPORT_DATA_MODAL:
                return <ImportDataModal {...this.props} />;
            case componentTypes.IMPORT_PRICE_DATA_MODAL:
                return <ImportPriceDataModal {...this.props} />;
            case componentTypes.MACHINE_ERRORS_MODAL:
                return <MachineErrorsModal {...this.props} />;
            case componentTypes.MASTER_PRODUCTS_MODAL:
                return <MasterProductsModal {...this.props} />;
            case componentTypes.MATCHING_COLORANTS_MODAL:
                return <MatchingColorantsModal {...this.props} />;
            case componentTypes.MATCHING_DISPENSE_FORMULA_MODAL:
                return <MatchingDispenseFormulaModal {...this.props} />;
            case componentTypes.MATCHING_MEASUREMENT_MODAL:
                return <MatchingMeasurementModal {...this.props} />;
            case componentTypes.NOTE_MODAL:
                return <NoteModal {...this.props} />;
            case componentTypes.ORDER_NOTIFICATION_MODAL:
                return <OrderNotificationModal {...this.props} />;
            case componentTypes.PARTIAL_UPDATE_MODAL:
                return <PartialUpdatesModal {...this.props} />;
            case componentTypes.PRINT_MODAL:
                return <PrintModal {...this.props} />;
            case componentTypes.PRINT_PREVIEW_MODAL:
                return <PrintPreviewModal {...this.props} />;
            case componentTypes.PRINT_PREVIEW_ORDER_MODAL:
                return <PrintPreviewOrderModal {...this.props} />;
            case componentTypes.PRINT_TASK_MODAL:
                return <PrintTaskModal {...this.props} />;
            case componentTypes.PRODUCT_FILE_PREVIEW_MODAL:
                return <ProductFilePreviewModal {...this.props} />;
            case componentTypes.PRODUCT_FILES_MODAL:
                return <ProductFilesModal {...this.props} />;
            case componentTypes.PROGRESS_BAR_MODAL:
                return <ProgressBarModal {...this.props} />;
            case componentTypes.PURGE_ALL_MODAL:
                return <PurgeAllModal {...this.props} />;
            case componentTypes.QUALITY_CONTROL_MODAL:
                return <QualityControlModal {...this.props} />;
            case componentTypes.RECIRCULATE_ALL_CHANNELS_MODAL:
                return <RecirculateAllChannelsModal {...this.props} />;
            case componentTypes.RECIRCULATE_CHANNELS_MODAL:
                return <RecirculateChannelsModal {...this.props} />;
            case componentTypes.RETINT_MODAL:
                return <RetintModal {...this.props} />;
            case componentTypes.SEARCH_IN_STANDARD_FORMULAS:
                return <SearchInStandardFormulasModal {...this.props} />;
            case componentTypes.SET_CANISTER_UFI_CODE_MODAL:
                return <SetCanisterUfiCodeModal {...this.props} />;
            case componentTypes.STIR_ALL_CANISTERS_MODAL:
                return <StirAllCanistersModal {...this.props} />;
            case componentTypes.TRANSLATION_MODAL:
                return <TranslationModal {...this.props} />;
            case componentTypes.TICKETING_MODAL:
                return <TicketingModal {...this.props} />;
            default:
                return <div />;
        }
    }
}
